import CustomSteps from '../../../../../v2-components/Antd/Steps';
import { handleDescription } from './handle/description.handle';
import { typeRetirement } from './constants/type-retirement.constant';

export default function TrackingProgress(props) {
	const preorderData = props?.data;
	const currentStatus = preorderData?.status; // PAYMENT_PENDING, PAYMENT_APPROVED, or PAYMENT_REJECTED
	const statusUpdatedAt = preorderData?.status_updated_at;
	const retirement = preorderData?.purchase_detail?.info?.type_retirement;

	// Map status strings to display
	const statusLabels = {
		'PAYMENT_PENDING': { label: 'Pre-orden por aprobar', order: 1 },
		'PAYMENT_APPROVED': { label: 'Pre-orden pagada', order: 2 },
		'PAYMENT_REJECTED': { label: 'Pre-orden rechazada', order: 3 },
	};

	// Build progress array based on current status
	const progress = [];
	
	if (currentStatus === 'PAYMENT_PENDING') {
		progress.push(currentStatus);
	} else if (currentStatus === 'PAYMENT_APPROVED') {
		progress.push('PAYMENT_PENDING');
		progress.push(currentStatus);
	} else if (currentStatus === 'PAYMENT_REJECTED') {
		progress.push('PAYMENT_PENDING');
		progress.push(currentStatus);
	}

	const steps = progress.map((progressStatus) => {
		const isCurrentStatus = currentStatus === progressStatus;
		const description = isCurrentStatus ? handleDescription(statusUpdatedAt) : '--';

		return {
			title: statusLabels[progressStatus]?.label || progressStatus,
			description: description,
		};
	});

	const current = steps.length - 1;

	return (
		<div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', marginRight: '10px' }}>
			<p>
				{typeRetirement[retirement]}
			</p>
			<h2>Tracking de pedido</h2>
			<CustomSteps progressDot size="small" direction="vertical" current={current} items={steps} />
		</div>
	);
}
